"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSapphireCreditScoreFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockSapphireCreditScoreFactory = /** @class */ (function (_super) {
    __extends(MockSapphireCreditScoreFactory, _super);
    function MockSapphireCreditScoreFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockSapphireCreditScoreFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockSapphireCreditScoreFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockSapphireCreditScoreFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockSapphireCreditScoreFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockSapphireCreditScoreFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockSapphireCreditScoreFactory;
}(contracts_1.ContractFactory));
exports.MockSapphireCreditScoreFactory = MockSapphireCreditScoreFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "score",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lastUpdated",
                type: "uint256",
            },
        ],
        name: "CreditScoreUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "DelayDurationUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "newDocumentId",
                type: "string",
            },
        ],
        name: "DocumentIdUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "updater",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "merkleRoot",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "updatedAt",
                type: "uint256",
            },
        ],
        name: "MerkleRootUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "merkleRootUpdater",
                type: "address",
            },
        ],
        name: "MerkleRootUpdaterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "pauseOperator",
                type: "address",
            },
        ],
        name: "PauseOperatorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "value",
                type: "bool",
            },
        ],
        name: "PauseStatusUpdated",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "currentEpoch",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "currentMerkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "documentId",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "getLastScore",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes32",
                name: "_merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_merkleRootUpdater",
                type: "address",
            },
            {
                internalType: "address",
                name: "_pauseOperator",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_maxScore",
                type: "uint16",
            },
        ],
        name: "init",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lastMerkleRootUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "maxScore",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "merkleRootDelayDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "merkleRootUpdater",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pauseOperator",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "setCurrentTimestamp",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "string",
                name: "_documentId",
                type: "string",
            },
        ],
        name: "setDocumentId",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_delay",
                type: "uint256",
            },
        ],
        name: "setMerkleRootDelay",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_merkleRootUpdater",
                type: "address",
            },
        ],
        name: "setMerkleRootUpdater",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "_value",
                type: "bool",
            },
        ],
        name: "setPause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_pauseOperator",
                type: "address",
            },
        ],
        name: "setPauseOperator",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "upcomingMerkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes32",
                name: "_newRoot",
                type: "bytes32",
            },
        ],
        name: "updateMerkleRoot",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "userScores",
        outputs: [
            {
                internalType: "uint256",
                name: "score",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lastUpdated",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_proof",
                type: "tuple",
            },
        ],
        name: "verifyAndUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=MockSapphireCreditScoreFactory.js.map